import { useEffect } from 'react';

const BASE_TITLE = 'MonQuiz.fr';

export default function usePageTitle(title) {
    useEffect(() => {
        document.title = title ? `${BASE_TITLE} — ${title}` : `${BASE_TITLE} — Aide à la préparation aux concours par QCM`;
        return () => { document.title = `${BASE_TITLE} — Aide à la préparation aux concours par QCM`; };
    }, [title]);
}
